import React, { FC } from 'react'
import { ASSETS } from '../../../../constants/assets'
import BlogCollectionRow from '../../blogCollectionRow'
import { CollectionRow } from '../style'

type Props = {
  blogPost: any
  collectionRowData: any
}

export const BlogPostGroup: FC<Props> = ({ blogPost, collectionRowData }) => {
  return (
    <>
      {blogPost && blogPost}
      <CollectionRow>
        <div className="CollectionRow__Background-Content"></div>

        <BlogCollectionRow
          className="BlogListing__Collection-Row"
          headline={collectionRowData?.headline || ''}
          robotImage={ASSETS.BLOG_POST_ROBOT}
          categories={
            collectionRowData?.teasers?.map((item: any) => ({
              name: item?.title || '',
              description: item?.description || '',
              ctaText: 'Explore collection',
            })) || []
          }
        />
      </CollectionRow>
    </>
  )
}
